import './RequireChangeFulfillmentOption.scss';

import { any } from 'prop-types';
import React, { useCallback, useState } from 'react';

import ModalComponent from '@components/Share/ModalComponent';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import { useCheckDeliveryOption } from '../../SlicingPage/CartDetails/CartFulfilmentOption/hooks';

const RequireChangeFulfillmentOption = ({ layoutData }) => {
  const { isLineExistOptionNotBOPIS, isBOPISOptionSelected } = useCheckDeliveryOption();
  const [isOpenModal] = useState(() => isBOPISOptionSelected && isLineExistOptionNotBOPIS);

  const handleCloseModal = useCallback(() => {
    window.location.href = layoutData?.['Back To Cart Link']?.value?.href;
  }, [layoutData]);

  return (
    <ModalComponent isShow={isOpenModal} onCloseHandler={handleCloseModal} titlePopup=''>
      <div className='require-change-fulfillment'>
        <div className='require-change-fulfillment__message'
          dangerouslySetInnerHTML={{ __html: layoutData?.['Require Change Fulfillment Option Popup Message']?.value }} />
        <div className='require-change-fulfillment__button'>
          <button className='btn btn-primary' onClick={handleCloseModal}>
            <Text field={layoutData?.['Require Change Fulfillment Option Popup Close Button Label']} />
          </button>
        </div>
      </div>
    </ModalComponent>
  );
};

RequireChangeFulfillmentOption.propTypes = {
  layoutData: any
};

export default RequireChangeFulfillmentOption;